/* Renderless component that syncs user properties to PostHog.
   Reactively updates when Convex subscription or source data changes. */

import { useEffect } from "react";
import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { setPostHogUserProperties } from "@/lib/posthog";
import { useSubscription } from "@/hooks/useSubscription";

export function PostHogUserProperties() {
  const { isPro } = useSubscription();
  const sourceCount = useQuery(api.sources.count);

  useEffect(() => {
    const tier = isPro ? "pro" : "free";
    setPostHogUserProperties({
      subscription_tier: tier,
      total_sources_count: sourceCount ?? 0,
      last_active_at: new Date().toISOString(),
    });
  }, [isPro, sourceCount]);

  return null;
}
